import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "truncate min-w-0 md:max-w-[22rem]" }
const _hoisted_2 = {
  key: 0,
  class: "absolute z-20 mt-2 w-80 rounded-md border border-gray-200 bg-white shadow-lg p-3"
}
const _hoisted_3 = {
  key: 0,
  class: "text-xs text-gray-500 mb-2"
}
const _hoisted_4 = {
  key: 1,
  class: "flex flex-wrap gap-2 mb-2"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["type", "placeholder"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 3,
  class: "mt-1 text-xs text-red-600"
}

import { DevicePhoneMobileIcon, EnvelopeIcon, PencilIcon, XMarkIcon } from '@heroicons/vue/24/outline'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'


export default {
  __name: 'NotificationEmailsPopover',
  props: {
  emails: { type: String, default: '' },
  canEdit: { type: Boolean, default: false },
  kind: { type: String, default: 'email' } // 'email' | 'phone'
},
  emits: ['update'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const containerRef = ref(null)
const open = ref(false)
const newEmail = ref('')
const error = ref('')

const isPhone = computed(() => props.kind === 'phone')
const triggerIcon = computed(() => (isPhone.value ? DevicePhoneMobileIcon : EnvelopeIcon))
const inputType = computed(() => (isPhone.value ? 'tel' : 'email'))
const placeholder = computed(() => (isPhone.value ? '+1 555 123 4567' : 'name@example.com'))
const invalidMessage = computed(() => (isPhone.value ? 'Enter a valid phone number' : 'Enter a valid email'))

const emailList = computed(() =>
  props.emails
    .split(',')
    .map(e => e.trim())
    .filter(Boolean)
)

const displayEmails = computed(() => emailList.value.join(', '))

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
// At least 7 digits; allow +, spaces, dashes, parens.
const PHONE_RE = /^\+?[\d\s().-]{7,}$/
const validator = computed(() => (isPhone.value ? PHONE_RE : EMAIL_RE))
const isValidNewEmail = computed(() => validator.value.test(newEmail.value.trim()))

function close() {
  open.value = false
  newEmail.value = ''
  error.value = ''
}

function onDocumentMousedown(event) {
  if (open.value && containerRef.value && !containerRef.value.contains(event.target)) {
    close()
  }
}

onMounted(() => {
  document.addEventListener('mousedown', onDocumentMousedown)
})

onBeforeUnmount(() => {
  document.removeEventListener('mousedown', onDocumentMousedown)
})

function addEmail() {
  const email = newEmail.value.trim()
  if (!validator.value.test(email)) {
    error.value = invalidMessage.value
    return
  }
  if (emailList.value.includes(email)) {
    error.value = 'Already added'
    return
  }
  const next = [...emailList.value, email].join(',')
  emit('update', next)
  newEmail.value = ''
  error.value = ''
}

function removeEmail(email) {
  const next = emailList.value.filter(e => e !== email).join(',')
  emit('update', next)
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "containerRef",
    ref: containerRef,
    class: "relative block max-w-full"
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "inline-flex items-center gap-1 text-sm text-gray-600 hover:text-gray-900 max-w-full",
      onClick: _cache[0] || (_cache[0] = $event => (open.value = !open.value))
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(triggerIcon.value), { class: "h-4 w-4 shrink-0" })),
      _createElementVNode("span", _hoisted_1, _toDisplayString(displayEmails.value || 'No recipients'), 1),
      (__props.canEdit)
        ? (_openBlock(), _createBlock(_unref(PencilIcon), {
            key: 0,
            class: "h-3.5 w-3.5 text-gray-400 shrink-0"
          }))
        : _createCommentVNode("", true)
    ]),
    (open.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (emailList.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "No recipients"))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emailList.value, (email) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: email,
                    class: "inline-flex items-center gap-1 rounded-full bg-gray-100 px-2 py-1 text-xs text-gray-800"
                  }, [
                    _createTextVNode(_toDisplayString(email) + " ", 1),
                    (__props.canEdit)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "text-gray-500 hover:text-gray-900",
                          onClick: $event => (removeEmail(email))
                        }, [
                          _createVNode(_unref(XMarkIcon), { class: "h-3 w-3" })
                        ], 8, _hoisted_5))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])),
          (__props.canEdit)
            ? (_openBlock(), _createElementBlock("form", {
                key: 2,
                class: "flex gap-2",
                onSubmit: _withModifiers(addEmail, ["prevent"])
              }, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((newEmail).value = $event)),
                  type: inputType.value,
                  placeholder: placeholder.value,
                  class: "flex-1 min-w-0 rounded-md border border-gray-300 px-2 py-1 text-xs focus:border-gray-500 focus:outline-none"
                }, null, 8, _hoisted_6), [
                  [_vModelDynamic, newEmail.value]
                ]),
                _createElementVNode("button", {
                  type: "submit",
                  class: "rounded-md border border-gray-300 bg-white px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50",
                  disabled: !isValidNewEmail.value
                }, " Add ", 8, _hoisted_7)
              ], 32))
            : _createCommentVNode("", true),
          (error.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(error.value), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

}